import React, { useState } from 'react';
import axios from 'axios';
import { Box, VStack, Heading, useToast } from '@chakra-ui/react';

const AddUser = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [refid, setRefid] = useState('');
  const [name, setName] = useState('');
  const [empcode, setEmpcode] = useState('');
  const [doj, setDoj] = useState('');
  const [officePhone, setOfficePhone] = useState('');
  const [mobile, setMobile] = useState('');
  const [status, setStatus] = useState('');
  const [rptOfficer, setRptOfficer] = useState('');
  const [designation, setDesignation] = useState('');
  const [department, setDepartment] = useState('');
  const [office, setOffice] = useState('');
  const [city, setCity] = useState('');
  const [email, setEmail] = useState('');

  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/Register/register`, {
        username,
        password,
        role,
        refid,
        name,
        empcode,
        doj,
        officePhone,
        mobile,
        status,
        rptOfficer,
        designation,
        department,
        office,
        city,
        email
      });

      if (response.status === 200) {
        toast({
          title: "User registered successfully",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setUsername('');
        setPassword('');
        setRole('');
        setRefid('');
        setName('');
        setEmpcode('');
        setDoj('');
        setOfficePhone('');
        setMobile('');
        setStatus('');
        setRptOfficer('');
        setDesignation('');
        setDepartment('');
        setOffice('');
        setCity('');
        setEmail('');
      }
    } catch (error) {
      const errorMessage = error.response?.status === 409 
        ? "A user with the same username already exists."
        : error.response?.data || error.message;

      toast({
        title: "Error registering user",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Box className="relative lg:w-[90%] md:w-1/2 w-full mx-auto mt-10">
      <form onSubmit={handleSubmit} className="relative bg-white rounded-2xl drop-shadow-md p-8 flex flex-col mt-10 space-y-6 z-10">
        <div className="flex items-center gap-4 border-b pb-3 border-gray-300">
          <Heading size="md" color="gray.800" fontWeight="medium">
            Add New User
          </Heading>
        </div>
        <VStack spacing="6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            <div>
              <label className="block text-sm font-medium">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter username"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Role</label>
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="" disabled>Select role</option>
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium">Refid</label>
              <input
                type="text"
                value={refid}
                onChange={(e) => setRefid(e.target.value)}
                placeholder="Enter Refid"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter Name"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Empcode</label>
              <input
                type="text"
                value={empcode}
                onChange={(e) => setEmpcode(e.target.value)}
                placeholder="Enter Empcode"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">DOJ</label>
              <input
                type="date"
                value={doj}
                onChange={(e) => setDoj(e.target.value)}
                placeholder="Enter Date of Joining"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Office Phone</label>
              <input
                type="text"
                value={officePhone}
                onChange={(e) => setOfficePhone(e.target.value)}
                placeholder="Enter Office Phone"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Mobile</label>
              <input
                type="text"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                placeholder="Enter Mobile"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Status</label>
              <input
                type="text"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                placeholder="Enter Status"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Reporting Officer</label>
              <input
                type="text"
                value={rptOfficer}
                onChange={(e) => setRptOfficer(e.target.value)}
                placeholder="Enter Reporting Officer"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Designation</label>
              <input
                type="text"
                value={rptOfficer}
                onChange={(e) => setDesignation(e.target.value)}
                placeholder="Enter Designation"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
           
            <div>
              <label className="block text-sm font-medium">City</label>
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                placeholder="Enter City"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Email"
                required
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        </VStack>
        <button type="submit" className="w-full py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">
          Add User
        </button>
      </form>
    </Box>
  );
};

export default AddUser;

